const STATUS_META = {
  inquiry: { label: "Inquiry", color: "#71717A" },
  quotation: { label: "Quotation", color: "#A855F7" },
  confirmed: { label: "Confirmed", color: "#0EA5E9" },
  design: { label: "Design", color: "#8B5CF6" },
  customer_approval: { label: "Cust. Approval", color: "#F59E0B" },
  design_approved: { label: "Design Approved", color: "#22C55E" },
  printing: { label: "Printing", color: "#00AEEF" },
  finishing: { label: "Finishing", color: "#EA580C" },
  quality_check: { label: "QC", color: "#F97316" },
  packing: { label: "Packing", color: "#0EA5E9" },
  ready: { label: "Ready", color: "#22C55E" },
  out_for_delivery: { label: "Out for Delivery", color: "#3B82F6" },
  delivered: { label: "Delivered", color: "#10B981" },
  completed: { label: "Completed", color: "#059669" },
  cancelled: { label: "Cancelled", color: "#EF4444" },
};

export default function StatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status, color: "#71717A" };
  return (
    <span
      className="inline-flex items-center gap-2 border px-2 py-1 text-xs font-semibold uppercase tracking-wider"
      style={{ borderColor: meta.color, color: meta.color }}
      data-testid={`status-${status}`}
    >
      <span className="status-dot" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
}

export { STATUS_META };
